import React, { useEffect, useState } from 'react';
import './Consultances.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faLightbulb, faCog, faHandsHelping } from '@fortawesome/free-solid-svg-icons';
import api from '../../api';

function Consultances() {
  const [articles, setArticles] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const userEmail = localStorage.getItem('userEmail');
  const [newComment, setNewComment] = useState({});
  const [newRating, setNewRating] = useState({});

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await api.get('/articles');
        setArticles(res.data);
      } catch (err) {
        console.error('Erreur lors du chargement des articles :', err);
      }
    };
    fetchArticles();
  }, []);

  const formatArticleContent = (text) => {
    if (!text) return '';

    // Si le contenu contient déjà du HTML (provenant de l'éditeur riche), le retourner tel quel
    if (/<[a-z][\s\S]*>/i.test(text)) {
      return text;
    }

    // Sinon, convertir le markdown (anciens articles)
    text = text
      .replace(/^# (.*)$/gm, '<h2>$1</h2>')
      .replace(/^## (.*)$/gm, '<h3>$1</h3>')
      .replace(/^(\d+)\. (.+)$/gm, '<h3>$1. $2</h3>')
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/_(.*?)_/g, '<em>$1</em>');
    const paragraphs = text
      .split(/\n{2,}/)
      .map(p => `<p>${p.trim().replace(/\n/g, ' ')}</p>`);
    return paragraphs.join('');
  };

  const handleAddComment = async (articleId) => {
    if (!newComment[articleId] && !newRating[articleId]) return;
    try {
      await api.post(`/articles/${articleId}/comments`, {
        username: userEmail || 'Anonyme',
        content: newComment[articleId],
        rating: newRating[articleId] || 0
      });
      setNewComment({ ...newComment, [articleId]: '' });
      setNewRating({ ...newRating, [articleId]: 0 });
      const res = await api.get('/articles');
      setArticles(res.data);
    } catch (error) {
      console.error('Erreur lors de l\'ajout du commentaire :', error);
    }
  };

  const renderStars = (note) =>
    '★'.repeat(Math.round(note)) + '☆'.repeat(5 - Math.round(note));

  const currentArticle = articles[currentIndex];

  return (
    <div className="service-page">
      <div className="consultances-header">
        <h1>Conseils & Consultance</h1>
        <p>Optimisez vos investissements immobiliers avec nos conseils stratégiques et personnalisés.</p>
      </div>

      <div className="consultances-content">
        <div className="consultances-text">
          <h2>Pourquoi choisir nos services de consultance ?</h2>
          <p>
            Chez <strong>Cabinet immobilier et de Consultance Juridique (CICJ)</strong>, nous offrons une expertise pointue pour vous aider à maximiser le potentiel de vos biens immobiliers. Que vous soyez un investisseur, un promoteur ou un propriétaire, nos services de consultance sont conçus pour répondre à vos besoins spécifiques et vous guider dans la prise de décisions éclairées.
          </p>

          <h3>Nos Domaines d'Intervention</h3>
          <div className="service-list">
            <div className="service-item-consultations">
              <FontAwesomeIcon icon={faChartLine} className="service-icon-consultations" />
              <div>
                <h4>Conseil en Investissement</h4>
                <p>Nous analysons les opportunités d'investissement et vous conseillons sur les meilleures stratégies pour maximiser vos rendements.</p>
              </div>
            </div>
            <div className="service-item-consultations">
              <FontAwesomeIcon icon={faLightbulb} className="service-icon-consultations" />
              <div>
                <h4>Stratégie de Développement</h4>
                <p>Nous vous aidons à élaborer des plans de développement immobilier qui répondent aux besoins du marché et aux objectifs financiers.</p>
              </div>
            </div>
            <div className="service-item-consultations">
              <FontAwesomeIcon icon={faCog} className="service-icon-consultations" />
              <div>
                <h4>Optimisation des Opérations</h4>
                <p>Nous identifions les améliorations possibles dans la gestion de vos biens pour optimiser les performances et réduire les coûts.</p>
              </div>
            </div>
            <div className="service-item-consultations">
              <FontAwesomeIcon icon={faHandsHelping} className="service-icon-consultations" />
              <div>
                <h4>Accompagnement Personnalisé</h4>
                <p>Nos experts sont à vos côtés pour vous conseiller à chaque étape de votre projet immobilier.</p>
              </div>
            </div>
          </div>

          <h3>Nos Zones d'Intervention</h3>
          <p>
            Nos services de consultance couvrent les régions de Dakar et de Thiès, ainsi que d'autres localités au Sénégal. Nous offrons des solutions sur mesure pour répondre aux particularités du marché immobilier local.
          </p>
        </div>

        <div className="consultances-images">
          <div className="image-card">
            <img src="/images/contact-support.png" alt="Contactez-nous" />
            <a href="/contact" className="image-link-consultations">Contactez-nous</a>
          </div>
          <div className="image-card">
            <img src="/images/gestionbien.jpg" alt="Gérez votre bien" />
            <a href="/confier-mon-bien" className="image-link-consultations">Confiez-nous votre bien</a>
          </div>
        </div>
      </div>

      {/* Section Articles intégrée */}
      {articles.length > 0 && (
        <div className="consultances-articles-section">
          <h2>Nos Articles & Conseils</h2>
          <div className="articles-layout">
            <div className="article-main">
              {currentArticle && (
                <div className="article">
                  <h3>{currentArticle.title}</h3>
                  {currentArticle.imageUrl && (
                    <img
                      src={currentArticle.imageUrl}
                      alt={currentArticle.title}
                      className="article-image"
                    />
                  )}
                  <div
                    className="formatted-article"
                    dangerouslySetInnerHTML={{ __html: formatArticleContent(currentArticle.content) }}
                  />

                  <div className="article-rating">
                    <strong>Note moyenne :</strong>{' '}
                    <span style={{ color: '#f4a100' }}>{renderStars(currentArticle.rating)}</span>{' '}
                    ({currentArticle.rating.toFixed(1)}/5)
                  </div>

                  <h4>Commentaires :</h4>
                  <ul className="comment-list">
                    {currentArticle.comments.map((c, idx) => (
                      <li key={idx}>
                        <strong>{c.username}</strong> ({renderStars(c.rating || 0)}): {c.content}
                      </li>
                    ))}
                  </ul>

                  <div className="comment-form">
                    <select
                      value={newRating[currentArticle._id] || 0}
                      onChange={(e) =>
                        setNewRating({ ...newRating, [currentArticle._id]: parseFloat(e.target.value) })
                      }
                    >
                      <option value={0}>Note</option>
                      {[1, 2, 3, 4, 5].map((n) => (
                        <option key={n} value={n}>
                          {n} étoile{n > 1 ? 's' : ''}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      placeholder="Laissez un commentaire"
                      value={newComment[currentArticle._id] || ''}
                      onChange={(e) =>
                        setNewComment({ ...newComment, [currentArticle._id]: e.target.value })
                      }
                    />
                    <button onClick={() => handleAddComment(currentArticle._id)}>Envoyer</button>
                  </div>

                  <div className="article-navigation">
                    <button onClick={() => setCurrentIndex((prev) => Math.max(prev - 1, 0))} disabled={currentIndex === 0}>
                      ◀ Précédent
                    </button>
                    <span>{currentIndex + 1} / {articles.length}</span>
                    <button
                      onClick={() => setCurrentIndex((prev) => Math.min(prev + 1, articles.length - 1))}
                      disabled={currentIndex === articles.length - 1}
                    >
                      Suivant ▶
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="article-sidebar">
              <h4>Autres articles</h4>
              <ul>
                {articles.map((article, idx) => (
                  <li key={article._id}>
                    <button onClick={() => setCurrentIndex(idx)} disabled={idx === currentIndex}>
                      {article.title.length > 40 ? article.title.slice(0, 40) + '...' : article.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Consultances;
